<template>
    <!-- 筛选栏 -->
    <el-card class="filter-card" shadow="never">
        <el-form :inline="true" :model="filters" class="filter-form">
            <el-form-item label="ID/用户名">
                <el-input v-model="filters.name" placeholder="请输入ID/用户名" clearable />
            </el-form-item>

            <el-form-item label="等级">
                <el-select v-model="filters.level" class="level-select" placeholder="请选择等级" clearable>
                    <el-option label="0" value="0" />
                    <el-option label="1" value="1" />
                    <el-option label="2" value="2" />
                    <el-option label="3" value="3" />
                    <el-option label="4" value="4" />
                    <el-option label="5" value="5" />
                </el-select>
            </el-form-item>

            <el-form-item>
                <el-button type="primary" @click="loadData">搜索</el-button>
                <el-button @click="resetFilters">重置</el-button>
            </el-form-item>
        </el-form>
    </el-card>

    <!-- 数据表格 -->
    <el-card class="table-card" shadow="never">
        <div class="table-wrapper">
            <el-table :data="rows" v-loading="loading" @sort-change="handleSortChange" style="width: 100%">
                <el-table-column prop="id" label="ID" width="200" sortable="custom">
                    <template #default="scope">
                        <el-link underline="always" type="primary" @click="viewUser(scope.row.id)">{{ scope.row.id
                            }}</el-link>
                        <CopyButton :text="scope.row.id" />
                    </template>
                </el-table-column>
                <el-table-column prop="name" label="Name" width="200" />
                <!-- <el-table-column prop="first_name" label="First Name" width="200" />
                <el-table-column prop="last_name" label="Last Name" width="200" /> -->
                <el-table-column prop="point" label="剩余积分" width="120" sortable="custom" />
                <el-table-column prop="deposit" label="总充值" width="100" sortable="custom" />
                <el-table-column prop="exp" label="经验" width="100" sortable="custom" />
                <el-table-column prop="level" label="等级" width="80" sortable="custom" />
                <el-table-column prop="invitationCode" label="邀请码" width="150">
                    <template #default="scope">
                        {{ scope.row.invitationCode }}
                        <CopyButton :text="scope.row.invitationCode" />
                    </template>
                </el-table-column>
                <el-table-column prop="createdAt" label="注册时间" width="200" sortable="custom">
                    <template #default="scope">
                        {{ $formatTime(scope.row.createdAt) }}
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!-- 分页 -->
        <div class="pagination-wrapper">
            <el-pagination v-model:current-page="filters.page" v-model:page-size="filters.size"
                :page-sizes="[10, 20, 50]" :total="filters.total" layout="total, sizes, prev, pager, next, jumper"
                @current-change="loadData" @size-change="loadData" />
        </div>
    </el-card>
</template>

<script setup>
import { ref, reactive, watch, onMounted } from "vue";
import { useRoute, useRouter } from 'vue-router';
import { apiCall } from "@/utils/api";

const route = useRoute();
const router = useRouter();

const loading = ref(false);

const rows = ref([]);

const filters = reactive({
    name: route.query.name || "",
    level: route.query.level || "",

    page: Number(route.query.page) || 1,
    size: Number(route.query.size) || 20,
    total: 0,

    sort: route.query.sort || "",
});

watch(
    filters,
    (val) => {
        router.replace({ query: { ...val } });
    },
    { deep: true }
);

async function loadData() {
    loading.value = true;

    const params = {
        page: filters.page || 1,
        size: filters.size || 20,
    };
    if (filters.name) {
        params.filter = filters.name;
    }
    if (filters.level) {
        params.level = filters.level;
    }
    if (filters.sort) {
        params.sort = filters.sort;
    }
    const response = await apiCall("user.getUsers", params);
    if (!response) {
        return false;
    }
    filters.total = response.count;
    rows.value = response.rows;

    loading.value = false;
}

async function resetFilters() {
    filters.name = "";
    filters.level = "";
    filters.page = 1;
    await loadData();
}

async function handleSortChange({ prop, order }) {
    filters.sort = `${prop},${order}`;
    await loadData();
}

function viewUser(id) {
    router.push(`/user/${id}`);
}

onMounted(async () => {
    await loadData();
});
</script>

<style scoped>
.level-select {
    width: 100px;
}
</style>
